// extracted by mini-css-extract-plugin
export default {"wrapper":"RecalculateButton_wrapper__KQqcC","icon":"RecalculateButton_icon__Vye5C","isLoading":"RecalculateButton_isLoading__RktWy","rotate":"RecalculateButton_rotate__rVT49"};